import { useState } from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import Logo from "components/common/Logo"
import styles from "./index.module.css"

/**
 * Logo shown at the top of a marketing email template. Uses the guide's custom logo
 * (`custom_logo_url` from the template API) and falls back to the Digital Sportsman / Sportswoman
 * logo when there is none or it fails to load.
 */
export const EmailTemplateLogo = ({ logoUrl, height, className }) => {
  const isSportsman = useSelector((state) => state.user.is_sportsman)
  // Remember which URL failed, so a template whose logo changes later isn't stuck on the fallback.
  const [brokenLogoUrl, setBrokenLogoUrl] = useState(null)

  if (logoUrl && logoUrl !== brokenLogoUrl) {
    return (
      <img
        src={logoUrl}
        alt="Logo"
        height={height}
        className={[styles.customLogo, className].filter(Boolean).join(" ")}
        onError={() => setBrokenLogoUrl(logoUrl)}
      />
    )
  }

  return <Logo className={className} alt="Logo" width={height} height={height} is_sportswoman={!isSportsman} wide />
}

EmailTemplateLogo.propTypes = {
  logoUrl: PropTypes.string,
  height: PropTypes.number.isRequired,
  className: PropTypes.string
}
